<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end;">
          <v-menu offset-y>
            <template v-slot:activator="{ on,attrs }">
              <v-btn 
              :loading="printAllButtonLoading"
              color="success"
              v-bind="attrs"
              v-on="on"
              >
                <v-icon>cloud_download</v-icon>Export
              </v-btn>
            </template>

            <v-list>
              <v-list-tile @click="printAllStockTransfer('printStockTransfer')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllStockTransfer()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{ showFilters ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="requestNo"
                label="Request No"
                type="text"
                v-model="queryParams.requestNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="stockTransferStatusList"
                label="Choose Stock Transfer Status ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="transferTypeList"
                label="Choose Stock Transfer Type ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.transferType"
              ></v-select>
            </v-flex>
            <v-flex sm3 v-if="user.role.roleName == 'ADMIN' || user.role.roleName == 'FINANCE_MANAGER'">
              <v-autocomplete
                v-model="queryParams.fromWarehouseId"
                :items="warehouseList"
                color="blue-grey lighten-2"
                :hide-no-data="true"
                label="Choose From Warehouse..."
                item-text="name"
                menu-props="auto"
                item-value="id"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3 v-if="user.role.roleName == 'ADMIN' || user.role.roleName == 'FINANCE_MANAGER'">
              <v-autocomplete
                :items="warehouseList"
                :hide-no-data="true"
                color="blue-grey lighten-2"
                label="Choose To Warehouse..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                v-model="queryParams.toWarehouseId"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3 v-if="user.role.roleName == 'WAREHOUSE_MANAGER'">
              <v-select
                :items="typeList"
                label="Choose Type ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="type"
                v-on:change="changeType()"
              ></v-select>
            </v-flex>
            <v-flex sm3 v-if="user.role.roleName == 'WAREHOUSE_MANAGER'">
              <v-autocomplete
                :items="warehouseList"
                :hide-no-data="true"
                color="blue-grey lighten-2"
                label="Choose Warehouse..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                v-model="queryParams.warehouseId"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="stockTransferList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.issueDateInMilliSeconds | format-ms-date }}</td>
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.requestNo }}</td>
              <td>{{ props.item.fromWarehouseName }}</td>
              <td>{{ props.item.fromBinName }}</td>
              <td>{{ props.item.toWarehouseName }}</td>
              <td>{{ props.item.toBinName }}</td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.type }}</td>
              <td>{{ props.item.description }}</td>
              <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- dialog -->
    <stockTransferExcel :isOpen="openDialog" v-on:change="dialogClose()"></stockTransferExcel>
    <div id="printStockTransfer" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center">
        <p style="font-size:18px;margin:1px">Stock Transfer Report</p>
      </div>
      <div style="text-align:center">
        <p
          style="font-size:15px;margin:1px"
        >From Date: [{{this.queryParams.fromDate | formatDate}}] To Date: [{{this.queryParams.toDate | formatDate}}]</p>
      </div>
      <div style="text-align:center">
        <p style="font-size:14px;margin:1px">Reported Date: [{{reportedDate}}]</p>
      </div>
      <br />
      <div style="padding-left:5px;padding-right:5px">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;
          width: 100%;font-size:12px;border-top:1px solid black"
        >
          <thead style="border:1px solid black;">
            <tr>
              <th style="border:1px solid black;text-align:center">Date</th>
              <th style="border:1px solid black;text-align:center">Invoice No</th>
              <th style="border:1px solid black;text-align:center">Product Code</th>
              <th style="border:1px solid black;text-align:center">Name</th>
              <th style="border:1px solid black;text-align:center">From Location</th>
              <th style="border:1px solid black;text-align:center">To Location</th>
              <th style="border:1px solid black;text-align:center">Qty</th>
            </tr>
          </thead>
           <tbody v-for="(header, index) in allStockTransferList" :key="index">
              <tr v-for="(item, i) in header.stockTransferItems" :key="i">
              <td style="border:1px solid black;text-align:left">{{ header.issueDateInMilliSeconds | format-ms-date }}</td>
              <td style="border:1px solid black;text-align:left">{{ header.issueNo }}</td>
              <td style="border:1px solid black;text-align:left">{{ item.productCode }}</td>
              <td style="border:1px solid black;text-align:left">{{ item.productName }}</td>
              <td style="border:1px solid black;text-align:left">{{ header.fromWarehouseName }}</td>
              <td style="border:1px solid black;text-align:left">{{ header.toWarehouseName }}</td>
              <td style="border:1px solid black;text-align:right"> {{ item.qty | decFormat(6) }}</td>
              </tr>
            </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { stockTransferService } from "../../services/stock-transfer-service";
import { warehouseService } from "../../services/warehouse-service";
import { commonService } from "../../services/common-service";
import stockTransferExcel from "../../components/stock-transfer/StockTransferExcel";

export default {
  name: "StockTransferList",
  components: { stockTransferExcel },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true
      },
      {
        text: "Purchase Reports",
        disabled: true
      },
      {
        text: "Stock Transfer Report",
        disabled: true
      }
    ],
    headers: [
      { text: "Issue Date", align: "left", value: "issueDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "Request No", value: "requestNo" },
      { text: "From Warehouse", value: "fromWarehouse.name" },
      { text: "From Bin", value: "fromBinName" },
      { text: "To Warehouse", value: "toWarehouse.name" },
      { text: "To Bin", value: "toBinName" },
      { text: "Status", value: "status" },
      { text: "Type", value: "type" },
      { text: "Description", value: "description" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "issueDate",
      totalItems: 0
    },
    transferTypeList: [
      { label: "----All----", value: "" },
      { label: "GOOD", value: "GOOD" },
      { label: "DAMAGE", value: "DAMAGE" }
    ],
    stockTransferStatusList: [],
    typeList: [
      { label: "TRANSFER", value: "TRANSFER" },
      { label: "RECEIVE", value: "RECEIVE" }
    ],
    printAllButtonLoading: false,
    stockTransferList: [],
    allStockTransferList: [],
    warehouseList: [],
    openDialog: false,
    totalRows: 0,
    reportedDate: commonService.formatDate(new Date(), "DD/MM/YYYY"),
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      requestNo: "",
      status: "",
      fromWarehouseId: "",
      toWarehouseId: "",
      warehouseId: "",
      transferType: ""
    }
  }),
  watch: {
    pagination: {
      handler() {
        this.getStockTransferList();
      },
      deep: true
    }
  },
  created() {
    if (this.user.role.roleName == "WAREHOUSE_MANAGER") {
      this.type = "TRANSFER";
    }
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.user.role.roleName == "ADMIN") {
      if (this.$route.query.fromWarehouseId) {
        this.queryParams.fromWarehouseId = this.$route.query.fromWarehouseId;
      }
      if (this.$route.query.toWarehouseId) {
        this.queryParams.toWarehouseId = this.$route.query.toWarehouseId;
      }
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.transferType) {
      this.queryParams.transferType = this.$route.query.transferType;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getWarehouseList();
    this.onSearch();
    this.changeType();
  },
  methods: {
    onSearch() {
      if (this.user.role.roleName == "WAREHOUSE_MANAGER" || this.user.role.roleName == "BRANCH_ADMIN") {
        if (this.type === "TRANSFER") {
          this.queryParams.fromWarehouseId = this.user.warehouseId;
          this.queryParams.toWarehouseId = this.queryParams.warehouseId;
        }
        if (this.type === "RECEIVE") {
          this.queryParams.toWarehouseId = this.user.warehouseId;
          this.queryParams.fromWarehouseId = this.queryParams.warehouseId;
        }
      }

      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "stock-transfer-report",
        query: this.queryParams
      });
      this.getStockTransferList();
    },
    changeType() {
      if (this.type === "TRANSFER" || this.user.roleName == "ADMIN") {
        this.stockTransferStatusList = [];
        this.stockTransferStatusList.push(
          "DRAFT",
          "DELIVERY",
          "FINISHED",
          "CANCEL"
        );
      }
      if (this.type === "RECEIVE") {
        this.stockTransferStatusList = [];
        this.stockTransferStatusList.push("DELIVERY", "FINISHED");
      }
    },

    getStockTransferList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      stockTransferService
        .getStockTransferList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.stockTransferList = res.data.stockTransferList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then(res => {
          this.warehouseList = res.data;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.warehouseList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
        });
    },
    printAllStockTransfer(divName) {
      this.printAllButtonLoading = true;
      stockTransferService
        .getAllStockTransferList(this.queryParams)
        .then(res => {
          if (res.data) {
            this.allStockTransferList = res.data.stockTransferList;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllButtonLoading = false;
        });
    },
    dialogClose() {
      this.openDialog = false;
      this.getStockTransferList();
    },
    exportAllStockTransfer() {
      this.printAllButtonLoading = true;
      stockTransferService
        .exportAllStockTransferExcel(this.queryParams)
        .then(res => {
          commonService.downloadE(res);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(()=>{
          this.printAllButtonLoading = false;
        });
    }
  }
};
</script>